'use client';

import { useEffect, useState } from 'react';
import { Wifi, WifiOff } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';

export default function OnlineStatusIndicator() {
  const [isOnline, setIsOnline] = useState(true);
  const [showStatus, setShowStatus] = useState(false);

  useEffect(() => {
    // Set initial status and show it briefly
    const online = navigator.onLine;
    setIsOnline(online);
    
    const updateOnlineStatus = () => {
      const nowOnline = navigator.onLine;
      setIsOnline(nowOnline);
      setShowStatus(true);

      // Hide status after 3 seconds if online
      if (nowOnline) {
        setTimeout(() => setShowStatus(false), 3000);
      }
    };

    window.addEventListener('online', updateOnlineStatus);
    window.addEventListener('offline', updateOnlineStatus);

    return () => {
      window.removeEventListener('online', updateOnlineStatus);
      window.removeEventListener('offline', updateOnlineStatus);
    };
  }, []);

  return (
    <AnimatePresence>
      {(showStatus || !isOnline) && (
        <motion.div
          initial={{ opacity: 0, y: -50 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -50 }}
          className={`fixed top-4 right-4 z-50 px-4 py-3 rounded-lg shadow-lg flex items-center gap-2 ${
            isOnline
              ? 'bg-green-500 text-white'
              : 'bg-red-500 text-white'
          }`}
        >
          {isOnline ? (
            <>
              <Wifi className="w-5 h-5" />
              <span className="font-semibold">Back Online</span>
            </>
          ) : (
            <>
              <WifiOff className="w-5 h-5" />
              <span className="font-semibold">No Internet Connection</span>
            </>
          )}
        </motion.div>
      )}
    </AnimatePresence>
  );
}
